import { nanoid } from "nanoid";
import { formatDistanceToNowStrict } from "date-fns";

const out = document.getElementById("out");
const meta = document.getElementById("meta");
const gen = document.getElementById("gen");
const copy = document.getElementById("copy");

let last = null;

function render() {
  if (!last) return;
  out.textContent = last.id;
  meta.textContent =
    `Generated ${formatDistanceToNowStrict(last.at, { addSuffix: true })} · ${last.at.toISOString()}`;
}

gen.addEventListener("click", () => {
  last = { id: nanoid(12), at: new Date() };
  render();
});

copy.addEventListener("click", async () => {
  if (!last) return;
  await navigator.clipboard.writeText(last.id);
  meta.textContent = "Copied to clipboard ✅";
  setTimeout(render, 800);
});
